import { z } from 'zod';
import { defineEndpoint } from '../define';

/** Drafts only (including stale drafts). Confirmed history is undeletable. */
export const deleteReleaseDraft = defineEndpoint({
  method: 'DELETE',
  path: '/v1/releases/:releaseId',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
